import React from "react";
import {SiteData} from "../../Constants/siteData";
import {PageWrapper} from "../../Components/PageWrapper/PageWrapper";
import PageHeader from "../../Components/common/PageHeader";
import ServicePageTemplate from "../../Containers/ServiceContainers/ServicePageTemplate";
import {SEO} from "../../Components/SEO/SEO";

export default function TreeTrimming() {
    return (
        <PageWrapper>
            <SEO title={SiteData.treeTrimming.metaData.title} description={SiteData.treeTrimming.metaData.description}/>
            <PageHeader header={SiteData.treeTrimming.h1} subtitle={SiteData.treeTrimming.subtitle}/>
            <ServicePageTemplate body={SiteData.treeTrimming.body}/>
        </PageWrapper>
    )
}
